import { TruckMinusIcon } from './TruckMinusIcon';

/**
 * author: Michael Richins
 * id 3F802DD6-094E-4C91-B78B-9790D1F39D9F
 * name truck-minus
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-minus.svg
 * tags
 * - Transportation + Road 
 */
export const TruckSubtractIcon = TruckMinusIcon;
export default TruckSubtractIcon